import { Modal, Text, Group } from '@mantine/core';

const CustomerDetails = ({ customer, detailsModal, setDetailsModal }) => {
    return (
        <Modal
            opened={detailsModal}
            onClose={() => setDetailsModal(false)}
            title="Detalles" // This is the customer's name and does not need translation
            size="lg"
            padding="lg"
        >

            <Group position="apart" style={{ marginBottom: 5, marginTop: 10 }}>
                <Text weight={500}>{customer.name}</Text>
            </Group>
            <Text size="sm" style={{ color: 'gray', lineHeight: 1.5 }}>
                <strong>Email:</strong> {customer.email}<br />
                <strong>Teléfono:</strong> {customer.phone}<br />
                <strong>Dirección:</strong> {customer.address}<br />
                <strong>Notas:</strong> {customer.notes}
            </Text>
        </Modal>
    );
};

export default CustomerDetails;
